export type Maybe<T> = T | null
export type If<T, V> = { __typename: T } & V
export type Operation<Data, Variables = undefined> = {
  query: string
  variables: Variables
}
export type ById<T> = { [id: string]: T | undefined }

export enum ENUM_COMPONENTSHAREDBENTOCARD_ICONKEY {
  catalog_card_2 = 'catalog_card_2',
  photo_drop = 'photo_drop',
  build_your_own_card = 'build_your_own_card',
  paper_plane_2 = 'paper_plane_2',
  personal_touch = 'personal_touch',
  candy = 'candy',
  gift_2 = 'gift_2',
  gift_card = 'gift_card',
  hand_written = 'hand_written',
  contact_card = 'contact_card',
  multi_card_campaign = 'multi_card_campaign',
  virtual_assistance = 'virtual_assistance',
  custom_brand = 'custom_brand',
}

export enum ENUM_COMPONENTSHAREDBENTOCARD_TYPE {
  content = 'content',
  product = 'product',
}

export enum ENUM_COMPONENTSECTIONSCARDTYPE_SECTIONTYPE {
  static_image = 'static_image',
  image_diff = 'image_diff',
  image_slider = 'image_slider',
}

export enum ENUM_COMPONENTSHAREDCARDSTORYITEM_KIND {
  card = 'card',
  text = 'text',
}

export enum ENUM_COMPONENTSHAREDCARDSTORYITEM_POSITION {
  top = 'top',
  center = 'center',
  bottom = 'bottom',
}

export enum ENUM_COMPONENTSHAREDCTA_KIND {
  external_url = 'external_url',
  internal_url = 'internal_url',
  app_route = 'app_route',
  app_action = 'app_action',
}

export type NormalizedComponentSharedSlide = {
  __typename: 'ComponentSharedSlide'
  id: string
  title: string
  description: string
  themeBgColor: Maybe<string>
  image: {
    url: string
  }
  button: Maybe<{
    textColorOverride: Maybe<string>
    backgroundColorOverride: Maybe<string>
    label: string
    kind: ENUM_COMPONENTSHAREDCTA_KIND
    url: Maybe<string>
    action: Maybe<string>
    route: Maybe<string>
  }>
}

export type NormalizedComponentSectionsBentoSections = {
  __typename: 'ComponentSectionsBentoSections'
  id: string
  bentoSection: Maybe<
    Maybe<{
      __typename: 'ComponentSectionsCardType'
      id: string
    }>[]
  >
}

export type NormalizedComponentSectionsCardType = {
  gridRowOverride: Maybe<string>
  cards: Maybe<{
    __typename: 'ComponentSharedBentoCard'
    id: string
  }>[]
  __typename: 'ComponentSectionsCardType'
  gridColumnOverride: Maybe<string>
  isComponentRight: Maybe<boolean>
  childrenGridArea: Maybe<{
    __typename: 'ComponentSharedGridArea'
    colStart: string
    colEnd: string
    rowEnd: string
    rowStart: string
  }>
  gridTitle: Maybe<string>
  imageDiffs: Maybe<
    Maybe<{
      __typename: 'ComponentSharedImageDiff'
      id: string
    }>[]
  >
  gridArea: Maybe<{
    __typename: 'ComponentSharedGridArea'
    colStart: string
    colEnd: string
    rowEnd: string
    rowStart: string
  }>
  bentoImage: Maybe<{
    imageUrl: {
      url: string
    }
  }>
  blobs: Maybe<{
    id: string
    option: Maybe<number>
    height: Maybe<string>
    width: Maybe<string>
    positionBottom: Maybe<string>
    glassBlur: Maybe<number>
  }>
  gridDescription: Maybe<string>
  id: string
  gridSubtitle: Maybe<string>
  sectionType: ENUM_COMPONENTSECTIONSCARDTYPE_SECTIONTYPE
}

export type NormalizedComponentSharedBentoCard = {
  __typename: 'ComponentSharedBentoCard'
  iconKey: ENUM_COMPONENTSHAREDBENTOCARD_ICONKEY
  detailsProduct: Maybe<{
    __typename: 'ComponentExpandProductPop'
    id: string
  }>
  gridArea: Maybe<{
    __typename: 'ComponentSharedGridArea'
    colStart: string
    colEnd: string
    rowEnd: string
    rowStart: string
  }>
  detailsContent: Maybe<{
    __typename: 'ComponentExpandContentPop'
    id: string
  }>
  title: string
  type: ENUM_COMPONENTSHAREDBENTOCARD_TYPE
  id: string
  description: Maybe<string>
}

export type NormalizedComponentExpandProductPop = {
  ctaLabel: Maybe<string>
  __typename: 'ComponentExpandProductPop'
  price: Maybe<number>
  title: string
  images: Maybe<{
    url: string
  }>[]
  categoryId: Maybe<string>
  id: string
  description: Maybe<string>
  sku: Maybe<string>
  ctaUrl: Maybe<string>
}

export type NormalizedComponentExpandContentPop = {
  __typename: 'ComponentExpandContentPop'
  id: string
  bannerImages: Maybe<{
    url: string
    alternativeText: Maybe<string>
  }>[]
  contentStream: Maybe<
    Maybe<{
      id: string
      title: Maybe<string>
      description: Maybe<string>
    }>[]
  >
  imageDiff: Maybe<{
    __typename: 'ComponentSharedImageDiff'
    id: string
  }>
}

export type NormalizedComponentSharedImageDiff = {
  __typename: 'ComponentSharedImageDiff'
  id: string
  leftImage: {
    url: string
  }
  leftAlt: Maybe<string>
  rightImage: {
    url: string
  }
  rightAlt: Maybe<string>
}

export type NormalizedComponentSectionsVideoBlocks = {
  __typename: 'ComponentSectionsVideoBlocks'
  id: string
  videoBlock: Maybe<
    Maybe<{
      id: string
      isComponentRight: Maybe<boolean>
      title: string
      description: Maybe<string>
      video: {
        iframeSrc: string
        thumbnailUrl: {
          url: string
        }
      }
      primaryAction: {
        id: string
        label: string
        action: Maybe<string>
        url: Maybe<string>
        kind: ENUM_COMPONENTSHAREDCTA_KIND
      }
    }>[]
  >
}

export type NormalizedData = {
  ComponentSharedSlide: ById<NormalizedComponentSharedSlide>
  ComponentSectionsBentoSections: ById<NormalizedComponentSectionsBentoSections>
  ComponentSectionsCardType: ById<NormalizedComponentSectionsCardType>
  ComponentSharedBentoCard: ById<NormalizedComponentSharedBentoCard>
  ComponentExpandProductPop: ById<NormalizedComponentExpandProductPop>
  ComponentExpandContentPop: ById<NormalizedComponentExpandContentPop>
  ComponentSharedImageDiff: ById<NormalizedComponentSharedImageDiff>
  ComponentSectionsVideoBlocks: ById<NormalizedComponentSectionsVideoBlocks>
}

export const NormalizedData = (): NormalizedData => ({
  ComponentSharedSlide: {},
  ComponentSectionsBentoSections: {},
  ComponentSectionsCardType: {},
  ComponentSharedBentoCard: {},
  ComponentExpandProductPop: {},
  ComponentExpandContentPop: {},
  ComponentSharedImageDiff: {},
  ComponentSectionsVideoBlocks: {},
})
